export const radioStyles = {
  padding: 0,
};
